import { axiosDelete, axiosGet, axiosPost, axiosPut } from "./ajaxServices";
import { urlRegisterUser } from "./CONSTANTS";
import api from "./api.js";

export const apiRegisterUser = async (param) => {
  const params = new FormData();
  params.append("registration_id", param.registration_id);
  params.append("registration_name", param.registration_name);
  params.append("yaccamp", param.yaccamp);
  params.append("reg_type", param.reg_type);
  params.append("camper_info", JSON.stringify(param.camperInfo));
  params.append("camper_reg", param.camperInfo.filter((f) => f.sel_reg_id.length != 0).length > 0);
  params.append("customer_data", JSON.stringify(param.userData));
  params.append("waiver_info", JSON.stringify(param.waiverList));

  params.append("bill_first_name", param.bill_first_name);
  params.append("bill_last_name", param.bill_last_name);
  params.append("bill_address", param.bill_address);
  params.append("bill_city", param.bill_city);
  params.append("bill_postal_code", param.bill_postal_code);
  params.append("bill_state", param.bill_state);

  params.append("discount_code", param.discount_code == undefined ? "" : param.discount_code);
  params.append("discount_amount", param.discount_amount);
  params.append("processing_fee", param.processing_fee);
  params.append("total_checkout", param.total_checkout);
  params.append("total_amount", param.src_total_amount);
  params.append("payment_gateway", param.isStax ? "stax" : "forte");
  params.append("payment_method", param.payment_method);
  params.append("transaction_id", param.transaction_id);
  params.append("entered_by", param.entered_by);
  params.append("authorization_code", param.authorization_code);
  params.append("location_id", param.location_id);
  for (let i = 0; i < param.recordList.length; i++) {
    params.append("camper_records[]", param.recordList[i]);
  }

  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };

  const { data } = await api.post("camp/register_user_dynamic", params, config);

  return data;
};

export const apiRegisterFailedPayment = async (param) => {
  const params = new FormData();
  params.append("err_res", param.err_res);
  params.append("api_name", param.api_name);
  params.append("p_cell_phone", param.p_cell_phone);
  params.append("p_email", param.p_email);
  params.append("p_first_name", param.p_first_name);
  params.append("p_home_phone", param.p_home_phone == undefined ? "" : param.p_home_phone);
  params.append("p_last_name", param.p_last_name);
  params.append("discount_code", param.discount_code == undefined ? "" : param.discount_code);
  params.append("discount_amount", param.discount_amount);
  params.append("processing_fee", param.processing_fee);
  params.append("total_checkout", param.total_checkout);
  params.append("total_amount", param.src_total_amount);
  params.append("payment_method", param.card_type);

  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };

  const { data } = await api.post("camp/register_failed_user", params, config);

  return data;
};

export const apiLogRegistrationStep = async (step, _data) => {
  const params = new FormData();
  params.append("step", step);
  params.append("registration_id", _data.registration_id);
  params.append("registration_name", _data.registration_name);
  params.append("reg_type", _data.reg_type);
  

  const appendFieldSafely = (key, value) => {
    // Ensure value is not undefined or null, otherwise send empty string
    params.append(key, (value !== undefined && value !== null) ? value : "");
  };

  // Step 1 data
  if (step >= 1) {
    // Camper info

    if (_data.camperInfo && _data.camperInfo.length > 0) {
      const firstCamper = _data.camperInfo[0]; // Process only the first camper
      appendFieldSafely("camper_first_name", firstCamper.camper_first_name);
      appendFieldSafely("camper_last_name", firstCamper.camper_last_name);
      appendFieldSafely("camper_age", firstCamper.camper_age);
      appendFieldSafely("camper_birthday", firstCamper.camper_birthday);
      appendFieldSafely("camper_email", firstCamper.camper_email);
      appendFieldSafely("camper_gender", firstCamper.camper_gender);
      appendFieldSafely("camper_grade", firstCamper.camper_grade);
      appendFieldSafely("camper_street", firstCamper.camper_street);
      appendFieldSafely("camper_city", firstCamper.camper_city);
      appendFieldSafely("camper_state", firstCamper.camper_state);
      appendFieldSafely("camper_zip", firstCamper.camper_zip);
      appendFieldSafely("camper_t_shirt", firstCamper.camper_t_shirt);
      appendFieldSafely("camper_health", firstCamper.camper_health);
   }
    // Parent info
    appendFieldSafely("p_first_name", _data.p_first_name);
    appendFieldSafely("p_last_name", _data.p_last_name);
    appendFieldSafely("p_email", _data.p_email);
    appendFieldSafely("p_cell_phone", _data.p_cell_phone);
    appendFieldSafely("p_home_phone", _data.p_home_phone);
    appendFieldSafely("p_relation", _data.p_relation);
    
  }
  
  // Step 2 data
  if (step >= 2) {
    // Registration and trip selections
    const firstCamper = _data.camperInfo[0];
    params.append("camper_sel_trip", firstCamper.sel_trip);
    params.append("camper_sel_reg_id", firstCamper.sel_reg_id.join(','));
    params.append("camper_reg", _data.camper_reg);
    
    // Waivers
    params.append("waivers", JSON.stringify(_data.waiverList));
  }
  
  // Step 3 data
  if (step >= 3) {
    // Billing info
    params.append("bill_first_name", _data.bill_first_name);
    params.append("bill_last_name", _data.bill_last_name);
    params.append("bill_address", _data.bill_address);
    params.append("bill_city", _data.bill_city);
    params.append("bill_postal_code", _data.bill_postal_code);
    params.append("bill_state", _data.bill_state);
    
    // Payment info
    params.append("discount_code", _data.discount_code);
    params.append("discount_amount", _data.discount_amount);
    params.append("processing_fee", _data.processing_fee);
    params.append("total_amount", _data.total_amount);
    params.append("total_checkout", _data.total_checkout);
    params.append("payment_method", _data.payment_method);
    params.append("payment_gateway", _data.isStax ? "stax" : "forte");
    
    // Additional payment fields
    params.append("sum_discount_amount", _data.discount_amount);
    params.append("sum_processing_fee", _data.processing_fee);
    params.append("sum_total_amount", _data.total_amount);
    params.append("sum_total_checkout", _data.total_checkout);
  }
  
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  // Log FormData entries before sending
  console.log("FormData being sent to camp/log_registration_step:");
  for (let pair of params.entries()) {
    console.log(pair[0] + ": ", pair[1]);
  }
  const { data } = await api.post("camp/log_registration_step", params, config);

  return data;
};